import { createAction, handleActions } from "redux-actions";
// - Actions
export const searchSliderRequest = createAction("SLIDER_LIST_SEARCH_REQUEST");
export const searchSliderSuccess = createAction("SLIDER_LIST_SEARCH_SUCCESS");

export const multipleSliderRequest = createAction("SLIDER_LIST_MULTIPLE_REQUEST");
export const multipleSliderSuccess = createAction("SLIDER_LIST_MULTIPLE_SUCCESS");

export const simpleSliderRequest = createAction("SLIDER_LIST_SIMPLE_REQUEST");
export const simpleSliderSuccess = createAction("SLIDER_LIST_SIMPLE_SUCCESS");

export const getAlbumsRequest = createAction("ALBUMS_LIST_REQUEST");
export const getAlbumsSuccess = createAction("ALBUMS_LIST_SUCCESS");

export const deleteSliderRequest = createAction("DELETE_SLIDER_REQUEST");

export const failure = createAction("ROLE_ACTION_FAILURE");

// - Initial State
export const initialState = {
  sliders: [],
  pagination: {
    pages: 1,
    page: 50,
    total: 0
  },
  multiples: [],
  loading: false,
  simples: [],
  simpling: false,
  error: null,

  albums: [],
  albumsLoading: false,
  albumsPagination: {
    size: 1,
    page: 50,
    total: 0
  },
};

// - Reducers
const reducer = handleActions(
  {
    [searchSliderRequest]: state => ({
      ...state,
      loading: true
    }),
    [searchSliderSuccess]: (state, { payload: { sliders, pagination } }) => ({
      ...state,
      sliders: sliders,
      pagination: pagination,
      loading: false
    }),

    [multipleSliderRequest]: state => ({
      ...state,
      loading: true
    }),
    [multipleSliderSuccess]: (state, { payload: { sliders } }) => ({
      ...state,
      multiples: sliders,
      loading: false
    }),

    [simpleSliderRequest]: state => ({
      ...state,
      simpling: true
    }),
    [simpleSliderSuccess]: (state, { payload: { sliders } }) => ({
      ...state,
      simples: sliders,
      simpling: false
    }),

    [getAlbumsRequest]: state => ({
      ...state,
      albumsLoading: true
    }),
    [getAlbumsSuccess]: (state, { payload: { albums, pagination } }) => ({
      ...state,
      albums: albums,
      albumsPagination: pagination,
      albumsLoading: false
    }),

    [failure]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error
    })
  },
  initialState
);

export default reducer;
